export default __webpack_public_path__ + "static/earth-hour-a2bcff47bcdb1173dd582ec19ffacde0.jpg";